module.exports = __webpack_public_path__ + "static/media/graphql.f86a1794.svg";